export const getFileExtension = (fileName: string): string =>
  (fileName.includes('.') && fileName.split('.').pop()) || '';
